
const Terms = () => {
  return (
    <div className="space-y-4">
      <h1 className="text-xl md:text-2xl font-bold">Terms and Conditions</h1>
      <p>By using our application, you agree to these terms and conditions. Please read them carefully.</p>
      
      <h2 className="text-lg md:text-xl font-semibold mt-4">Use License</h2>
      <p>Permission is granted to temporarily use this application for personal, non-commercial purposes only.</p>
      
      <h2 className="text-lg md:text-xl font-semibold mt-4">Disclaimer</h2>
      <p>The information provided by this application is for general informational purposes only and is not intended as a substitute for professional medical advice.</p>
      
      <h2 className="text-lg md:text-xl font-semibold mt-4">Limitations</h2>
      <p>In no event shall we be liable for any damages arising out of the use or inability to use the materials on our application.</p>
      
      <h2 className="text-lg md:text-xl font-semibold mt-4">Revisions</h2>
      <p>We may revise these terms of use at any time without notice. By using this application, you agree to be bound by the current version of these terms of service.</p>
    </div>
  );
};

export default Terms;
